import React, { useEffect, useState } from 'react';
import { Tooltip } from "../Global/Tooltip";
import System from 'src/helper/system';
import { useCartStore } from 'src/hooks/cart';
import Constants from 'src/helper/Constants';
import useReduxState from 'src/hooks/useReduxState';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';

const CustomerPartNumberOptions = (props) => {
    const { single_product, from = "", updationCompletedCallback, defaultValue, unique_id, isFrom } = props;
    const [selectedCpn, setSelectedCpn] = useState('');
    let c = System.getParams();
    const [{ }, { }, { SET_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT }] = useCartStore();
    const [, setQtyLoader] = useReduxState(false, 'setQtyLoader');
    const { systemModules: { CART, BOM } } = Constants
    const { translation: t } = System;
    const [__check] = useAxiosIndicatorCheck();

    useEffect(() => {
        if (c.search || c.searchTerm) {
            const searchedCPN = c.search || c.searchTerm;
            let cpnAvailable = System.isCPNAvailableInList(single_product, searchedCPN)
            if (cpnAvailable) {
                onSelectCPN(searchedCPN)
            }
        }
    }, [])

    useEffect(() => {
        if (defaultValue) {
            onSelectCPN(defaultValue)
        } else if (single_product?.CustomerPartNumbers?.length === 1) {
            onSelectCPN(single_product?.CustomerPartNumbers[0].CPN)
        }
    }, [defaultValue])

    const onSelectCPN = async (cpnVal, selectedFromDropdown = false) => {
        setSelectedCpn(cpnVal)

        if (single_product) {
            SET_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT({ CPN: cpnVal, ItemNumber: single_product?.ItemNumber })
                if (selectedFromDropdown && (from === CART || from === BOM)) {
                    updationCompletedCallback(cpnVal)
                }
            setQtyLoader(false)
        }
    }

    return (
        <>
            {single_product?.CustomerPartNumbers?.length > 0 &&
                <div className="form-group">
                    <label htmlFor="sel1" className="text-nowrap"><b>{t('customerPartNumber')}</b>
                        {single_product?.CustomerPartNumbers?.length > 1 &&
                            <Tooltip
                                opener={() => (<i className="fa fa-info-circle ms-1" />)}
                                content={() => (
                                    <>
                                        {t('clickToSelectCPN')}
                                    </>
                                )}
                            />
                        }
                    </label>

                    {single_product?.CustomerPartNumbers?.length > 1 ?

                        <div className="selectbox">
                            <select
                                className="form-control form-control-xs"
                                onChange={async (e) => { onSelectCPN(e.target.value, true) }}
                                disabled={(isFrom === Constants.systemModules.CART) && __check(["CART_OPERATION_API_CALL", "VIEW_CART_API_CALL"]).status}
                                value={selectedCpn}
                                id="Customer" aria-labelledby="Choose CPN">
                                <option value="" selected>{t('selectCPN')}</option>
                                {single_product?.CustomerPartNumbers.map((v, i) => (
                                    <React.Fragment key={i}>
                                        <option value={v.CPN}>{v.CPN}</option>
                                    </React.Fragment>
                                ))}
                            </select>
                        </div> :
                        <div>
                            {selectedCpn}
                        </div>
                    }
                </div>
            }
        </>
    );
};

export default CustomerPartNumberOptions;